export default __webpack_public_path__ + "static/adi-45ac44a86dcf2f60a3418a45ca133847.jpg";